import * as React from 'react';
import styled from 'styled-components';
import { LibraryBooks } from '@material-ui/icons';
import { useState } from 'react';
import useTablePage from '../../../hooks/useTablePage';
// import DashboardLayout from '../../layouts/DashboardLayout';
import {
  getFormSetupList,
  createFormSetup,
  editFormSetup,
  deleteFormSetup,
} from '../../../api/formSetup';
import ActionsPanel from '../../../organisms/ActionsPanel';
import Table from '../../../organisms/Table';
import { convertTableBoolean } from '../../../utils/convertTableValues';
import tableColumnsFormatter from '../../../utils/tableColumnsFormatter';
import {
  ModalDefaultDraggable,
  ModalDeleteConfirmation,
} from '../../../molecules';
import FormSetupForm from '../../../forms/FormSetupForm';
import { getJurisdictions } from '../../../api/jurisdiction';
import { GET_ALL_QUERY_PARAMS } from '../../../constants';
import EditFormSetupPlaceholders from '../../../organisms/EditFormSetupPlaceholders';
import DashboardLayout from '../../../layouts/DashboardLayout';
import AddNewForm from './AddNewForm';
import FormsTable from './FormsTable';

const FillableFormSetupPage = () => {
  const {
    search,
    setSearch,
    isModalOpen,
    updateTable,
    modalTitle,
    values,
    errors,
    modalErrorTitle,
    tableManuallyUpdate,
    createOrUpdate,
    deleteById,
    selectedItem,
    setSelectedItem,
    handleEdit,
    handleDelete,
    handleCloseModal,
  } = useTablePage({
    createEndpoint: createFormSetup,
    updateEndpoint: editFormSetup,
    deleteEndpoint: deleteFormSetup,
    modalCreateTitle: 'Add New Form',
  });

  const [showAdd, setShowAdd] = useState<boolean>(false);
  const [
    editPlaceholdersData,
    setEditPlaceholdersData,
  ] = React.useState(null);

  const [
    selectedFontSize,
    setSelectedFontSize,
  ] = React.useState(12);

  const modifiedGetFormSetupRequest = params =>
    Promise.all([
      getFormSetupList(params),
      getJurisdictions({ ...GET_ALL_QUERY_PARAMS }),
    ]).then(
      ([formSetupResponse, jurisdictionsResponse]) => {
        return {
          ...formSetupResponse,
          data: {
            ...formSetupResponse.data,
            results: formSetupResponse.data.results.map(
              form => ({
                ...form,
                jurisdiction: jurisdictionsResponse.data.results
                  ?.filter(jur =>
                    form.jurisdictions.includes(jur.id),
                  )
                  .map(el => el.name)
                  .join(', '),
              }),
            ),
          },
        };
      },
    );

  const handleAdd = () => {
      setShowAdd(true);
  };

  return (
    <DashboardLayout>
      {showAdd && (
        <ModalDefaultDraggable
          title="Add New Manual Form"
          onClose={() => setShowAdd(false)}
        >
          <AddNewForm initialValues={undefined} selectedFontSize={16} setShowAdd={setShowAdd} />
        </ModalDefaultDraggable>)}
      <PageWrapper>
        <ActionsPanel
          onSearch={setSearch}
          onAdd={handleAdd}
        />
      <Container>
        <FormsTable />
      </Container>
      {selectedItem && (
        <ModalDeleteConfirmation
          onCancel={() => setSelectedItem(null)}
          onConfirm={() => deleteById(selectedItem.id)}
        >
          <strong>{selectedItem.name}</strong>
        </ModalDeleteConfirmation>
      )}
      <EditFormSetupPlaceholders
        data={editPlaceholdersData}
        setData={setEditPlaceholdersData}
        updateTable={updateTable}
        setSelectedFontSize={setSelectedFontSize}
        selectedFontSize={selectedFontSize}
      />
      {isModalOpen && (
        <StyledModalDraggable
          onClose={handleCloseModal}
          title={modalTitle}
        >
          <FormSetupForm
            onSubmit={createOrUpdate}
            initialValues={values}
            initialErrors={errors}
            modalError={modalErrorTitle.length > 0}
            setSelectedFontSize={setSelectedFontSize}
            selectedFontSize={selectedFontSize}
          />
        </StyledModalDraggable>
      )}
      </PageWrapper>
    </DashboardLayout>
  );
};

const PageWrapper = styled.div`
  width: 100%;
  padding: 20px 16px 0;
  box-sizing: border-box;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont,
    'Helvetica Neue', Arial, Roboto, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';

  @media (max-width: 840px) {
    padding: 12px 12px 0;
  }
`;

const Container = styled.div`
  margin: 20px 0 0 0;
`;

const StyledModalDraggable = styled(ModalDefaultDraggable)`
  height: 100%;
  overflow: inherit;
`;

export default FillableFormSetupPage;
